<template>
  <svg :class="$attrs.class"
  :width="width + 'px'" 
  viewBox="0 0 96 96" 
  version="1.1" 
  xmlns="http://www.w3.org/2000/svg" 
  xmlns:xlink="http://www.w3.org/1999/xlink">
      <component :is="iconComp"></component>
  </svg>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  import Scooter from './icons/scooter.vue';
  import Pickup from './icons/pickup.vue';
  import Light from './icons/light.vue';
  import Typical from './icons/typical.vue';
  import Hungry from './icons/hungry.vue';
  import Vegan from './icons/vegan.vue';

  const props = defineProps({
    height: {
      type: String,
      default: '24',
    },
    width: {
      type: String,
      default: '24',
    },
    type: {
      type: String,
      required: true,
    },
  });

  const iconComp = computed(() => {
    let iconComponent = Scooter;

    switch(props.type) { 
      case 'scooter': { 
        iconComponent = Scooter;
        break; 
      }
      case 'pickup': {
        iconComponent = Pickup;
        break;
      }
      case 'light': { 
        iconComponent = Light;
        break; 
      }
      case 'typical': {
        iconComponent = Typical;
        break;
      }
      case 'hungry': {
        iconComponent = Hungry;
        break;
      }
      case 'vegan': {
        iconComponent = Vegan;
        break;
      }
    }

    return iconComponent
  })

</script> 